/**
 * Runtime Environment Configuration
 * Reads from window.__ENV__ (runtime) with fallback to process.env (build-time)
 */

interface RuntimeEnv {
  NX_PUBLIC_BASE_URL?: string;
  NX_PUBLIC_ADMIN_BASE_URL?: string;
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

/**
 * Get environment variable with runtime override support
 * Priority: window.__ENV__ > process.env
 */
export function getRuntimeEnv(key: keyof RuntimeEnv): string | undefined {
  // Check runtime config first (only in browser)
  if (typeof window !== "undefined" && window.__ENV__?.[key]) {
    return window.__ENV__[key];
  }

  // Fallback to build-time value
  return process.env[key];
}

export const getRuntimeBaseUrl = (): string | undefined =>
  getRuntimeEnv("NX_PUBLIC_BASE_URL");

export const getRuntimeAdminBaseUrl = (): string | undefined =>
  getRuntimeEnv("NX_PUBLIC_ADMIN_BASE_URL");
